import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'fault-logitem-tag',
  props: {
    isBoom: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { isBoom: boolean };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tag", props.isBoom ? 'tag-light' : ''])
  }, _toDisplayString(props.isBoom ? '' : '未') + "检测到炸机 ", 3))
}
}

})